import { Breadcrumbs, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useBreadcrumbs } from "src/shared/providers/BreadcrumbsProvider";

const GlobalBreadcrumbs = () => {
  const { breadcrumbs } = useBreadcrumbs();

  return (
    <Breadcrumbs aria-label="breadcrumb">
      {breadcrumbs.map((crumb, index) =>
        index < breadcrumbs.length - 1 ? (
          <Link
            key={crumb.path}
            component={RouterLink}
            to={crumb.path}
            underline="hover"
            color="inherit"
          >
            {crumb.label}
          </Link>
        ) : (
          <Typography key={crumb.path} color="text.primary">
            {crumb.label}
          </Typography>
        ),
      )}
    </Breadcrumbs>
  );
};

export default GlobalBreadcrumbs;
